import type { FunctionComponent } from 'react';

import { useNbFacetValues } from '@/productDiscovery/Listings/facets/hooks/useNbFacetValues';
import { useNbRefinedFacets } from '@/productDiscovery/Listings/facets/hooks/useNbRefinedFacets';
import { usePageName } from '@/productDiscovery/Listings/hooks/usePageName';

import { MultiSelectFilter } from '../MultiSelectFilter/MultiSelectFilter';
import { CategoriesRadioSelectFilter } from './components/CategoriesRadioSelectFilter/CategoriesRadioSelectFilter';

export interface CategoriesFilterProps {
  className?: string;
  title: string;
  facetName: string;
  position?: number;
  filterCount?: number;
}

export const CategoriesFilter: FunctionComponent<CategoriesFilterProps> = ({
  className,
  title,
  facetName,
  position,
  filterCount,
}) => {
  const nbCategories = useNbFacetValues(facetName);
  const nbRefinedFacets = useNbRefinedFacets();
  const page = usePageName();
  const withRadioSelect = page !== 'commercialOperationListing';

  if (!(nbCategories > 1 || (nbCategories === 1 && nbRefinedFacets > 0)))
    return null;

  return withRadioSelect ? (
    <CategoriesRadioSelectFilter
      className={className}
      facetName={facetName}
      title={title}
      position={position}
      filterCount={filterCount}
    />
  ) : (
    <MultiSelectFilter
      className={className}
      facetName={facetName}
      title={title}
      position={position}
      filterCount={filterCount}
    />
  );
};

CategoriesFilter.displayName = 'CategoriesFilter';
